import apiService from './apiServices';

const LOCAL_KEY_PREFIX = 'presenceEvents:'; // per day storage if server fails

function dayKey(date = new Date()) {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = ('0' + (d.getMonth() + 1)).slice(-2);
  const da = ('0' + d.getDate()).slice(-2);
  return `${y}-${m}-${da}`;
}

function loadLocal(day) {
  try {
    const raw = localStorage.getItem(LOCAL_KEY_PREFIX + day);
    return raw ? JSON.parse(raw) : [];
  } catch (_) { return []; }
}

function saveLocal(day, list) {
  try { localStorage.setItem(LOCAL_KEY_PREFIX + day, JSON.stringify(list || [])); } catch (_) {}
}

// True only when the backend is genuinely unreachable (offline / gateway down),
// in which case writing locally is the right resilience behaviour. A 4xx/5xx
// application error is NOT offline — it must surface to the caller.
function isOffline(e) {
  const msg = (e?.message || '').toLowerCase();
  return (
    e instanceof TypeError ||
    msg.includes('failed to fetch') ||
    msg.includes('networkerror') ||
    msg.includes('network request failed') ||
    msg.includes('load failed') ||
    msg.includes('offline') ||
    msg.includes('502') || msg.includes('503') || msg.includes('504')
  );
}

export default function presenceService() {
  const table = 'attendanceEvents'; // adjust to backend table name if different
  return {
    async addEvent({ type, workerId, at = new Date().toISOString(), meta = {} }) {
      const payload = { Type: type, WorkerId: workerId, At: at, ...meta };
      try {
        const res = await apiService().post(table, payload);
        if (res && res.success) return res;
        // Server answered but rejected the event → surface it, don't fake success.
        throw new Error(res?.error || 'Ngjarja u refuzua nga serveri');
      } catch (e) {
        // Real server/validation error → propagate so the UI can show it.
        if (!isOffline(e)) throw e;
        // Genuinely offline → keep working locally so nothing is lost.
        const day = dayKey(new Date(at));
        const list = loadLocal(day);
        list.push({ type, workerId, at, ...meta, _local: true });
        saveLocal(day, list);
        return { success: true, data: { id: `local_${list.length}`, _local: true } };
      }
    },
    async getDay(date = new Date()) {
      const day = dayKey(date);
      // try server query first
      try {
        const r = await apiService().query('getAttendanceByDay', `date=${day}`);
        if (r?.success) return r.data || [];
      } catch (_) {}
      return loadLocal(day);
    },
    async getRange(from, to) {
      const f = dayKey(new Date(from));
      const t = dayKey(new Date(to));
      try {
        const r = await apiService().query('getAttendanceRange', `from=${f}&to=${t}`);
        if (r?.success) return r.data || [];
      } catch (_) {}
      // aggregate local
      const start = new Date(f);
      const end = new Date(t);
      const all = [];
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const key = dayKey(d);
        loadLocal(key).forEach((e) => all.push({ ...e, day: key }));
      }
      return all;
    },
  };
}

